import { Helmet } from 'react-helmet-async';
import PageHeader from 'app/design/speedBot/PageHeader';
import FormattedMessage from 'app/design/uiComponents/FormattedMessage';
import { PAGES } from 'app/components/Common/Breadcrumb/types';
import Breadcrumbs from 'app/design/uiComponents/Breadcrumbs';
import WalletDetails from 'app/components/Menu/WalletDetails';

export function MenuWalletPage() {
  return (
    <>
      <Helmet>
        <title>Wallet</title>
        <meta name="description" content="Wallet Page" />
      </Helmet>
      <PageHeader
        variant="inactive"
        buttonText={<FormattedMessage id="menu.page_title.menu" />}
        title={<FormattedMessage id="menu.wallet" />}
        buttonHandleClick="/menu"
        breadcrumb={<Breadcrumbs page={PAGES.WALLET} data={{}} />}
      />
      <WalletDetails />
    </>
  );
}
